;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Button from 'components/ui/Button';
import ButtonCTA from 'components/ui/ButtonCTA';
import Icon from 'components/ui/Icon';
import Text from 'components/ui/Text';

import styles from './TextLockup.module.scss';

const TextLockup = ({
    eyebrow,
    headline,
    richHeadline,
    bodyCopy,
    cta,
    ctaSecondary,
    className = null,
    theme,
    icon,
}) => {
    theme ??= 'Default';

    return (
        <div
            className={cx(styles.textLockup, className, {
                [styles.hasRichHeadline]: richHeadline,
            })}
        >
            {icon?.icon?.url && (
                <div>
                    <Icon src={icon?.icon?.url} contained />
                </div>
            )}
            {eyebrow && (
                <div className={styles.eyebrow}>
                    <Text
                        baseTheme="labelSmall"
                        themes={{
                            xLarge: 'labelLarge',
                        }}
                    >
                        {eyebrow}
                    </Text>
                </div>
            )}
            {headline && !richHeadline && (
                <div className={styles.headline}>
                    <Text
                        baseTheme="displayXSmall"
                        themes={{
                            large: 'displayMedium',
                            xxLarge: 'displayLarge',
                        }}
                    >
                        {headline}
                    </Text>
                </div>
            )}
            {richHeadline?.content && (
                <div className={styles.headline}>
                    <Text
                        baseTheme="displayXSmall"
                        themes={{
                            large: 'displayMedium',
                            xLarge: 'displayLarge',
                        }}
                    >
                        {richHeadline?.json.content.map((line, i) => {
                            if (line.content[0].value === '') {
                                return null;
                            }
                            return (
                                <span className={styles.line} key={i}>
                                    {line.content[0].value}
                                </span>
                            );
                        })}
                    </Text>
                </div>
            )}
            {bodyCopy && (
                <div className={styles.copy}>
                    <Text
                        baseTheme="bodySmall"
                        themes={{
                            xLarge: 'bodyMedium',
                        }}
                    >
                        {bodyCopy}
                    </Text>
                </div>
            )}

            {cta?.text && cta?.link && !ctaSecondary && (
                <div className={styles.buttonWrapper}>
                    <Button
                        className={styles.cta}
                        theme={
                            theme !== 'Default'
                                ? 'outlinedCream'
                                : 'outlinedBlue'
                        }
                        entry={cta.link}
                    >
                        {cta.text}
                    </Button>
                </div>
            )}
            {(ctaSecondary?.link || ctaSecondary?.assetDownloadLink) && (
                <div className={styles.buttonWrapper}>
                    <ButtonCTA {...ctaSecondary} />
                </div>
            )}
        </div>
    );
};

TextLockup.propTypes = {
    eyebrow: PropTypes.string,
    headline: PropTypes.string,
    richHeadline: PropTypes.object,
    bodyCopy: PropTypes.string,
    cta: PropTypes.object,
    ctaSecondary: PropTypes.object,
    className: PropTypes.string,
    theme: PropTypes.oneOf([
        'Default',
        'Holiday Blue',
        'Special Holiday Blue',
        'Special Holiday Rust',
        'Special Holiday Squash',
    ]),
    icon: PropTypes.object,
};

export default TextLockup;
